import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';

@Pipe({
    name: 'getClass',
    standalone: false
})
export class GetClassPipe implements PipeTransform {
  constructor(public commonService: CommonService) { }
  transform(value: any, cond: any, ...args: any[]): any {
    let val;
    if (args.length > 0 && args[0] != undefined && args[0]=="text_true") {
      val = this.commonService.getText(value, cond);
    }
    else {
      val = this.commonService.getClass(value, cond);
    }
    return val;
  }

}
